import { render, staticRenderFns } from "./disease-about.vue?vue&type=template&id=caca0e5e&scoped=true"
import script from "./disease-about.vue?vue&type=script&lang=js"
export * from "./disease-about.vue?vue&type=script&lang=js"
import style0 from "./disease-about.vue?vue&type=style&index=0&id=caca0e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caca0e5e",
  null
  
)

export default component.exports